import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';

const Footer = ({ language }) => {
  const content = {
    en: {
      about: {
        title: 'Shree Digital Solutions And Services',
        description: 'Your trusted E-Seva Kendra providing comprehensive government and private services with dedication and efficiency.'
      },
      quickLinks: {
        title: 'Quick Links',
        links: ['Home',  'Blogs', 'Contact', 'Privacy Policy', "Terms and Conditions", "Copyright"]
      },
      services: {
        title: 'Our Services',
        items: ['Pan Card', 'Voter ID', 'Aadhaar Card', 'Passport', 'Ration Card', 'Income Certificate']
      },
      contact: {
        title: 'Contact Us',
        email: 'admin@shreeservz.com',
        phone: '+91 9321415838',
        address: 'Thane, Maharashtra, India'
      },
      followUs: 'Follow Us',
      copyright: '© 2025 Shree Digital Solutions And Services E-Seva Kendra. All rights reserved.',
      designedBy: 'Designed with ❤️ for the people'
    },
    mr: {
      about: {
        title: 'श्री डिजिटल सोल्यूशन्स अँड सर्व्हिसेस',
        description: 'आपली विश्वासू ई-सेवा केंद्र जी समर्पण आणि कार्यक्षमतेसह सर्व सरकारी आणि खाजगी सेवा प्रदान करते.'
      },
      quickLinks: {
        title: 'द्रुत दुवे',
        links: ['मुख्यपृष्ठ',  'ब्लॉग', 'संपर्क', 'गोपनीयता नीति',"अटी व शर्ती", "कॉपीराइट"]
      },
      services: {
        title: 'आमच्या सेवा',
        items: ['पॅन कार्ड', 'मतदार ओळखपत्र', 'आधार कार्ड', 'पासपोर्ट', 'रेशन कार्ड', 'उत्पन्न प्रमाणपत्र']
      },
      contact: {
        title: 'आमच्याशी संपर्क साधा',
        email: 'admin@shreeservz.com',
        phone: '+91 9321415838',
        address: 'ठाणे, महाराष्ट्र, भारत'
      },
      followUs: 'आमचे अनुसरण करा',
      copyright: '© 2025 श्री डिजिटल सोल्यूशन्स अँड सर्व्हिसेस ई-सेवा केंद्र. सर्व हक्क राखीव.',
      designedBy: 'लोकांसाठी ❤️ ने डिझाइन केलेले'
    }
  };

  const currentContent = content[language];
  const routes = ['/', '/blogs', '/contact', '/privacy-policy','/terms-and-conditions','/copyright', '/services', '/about', ];

  return (
    <>
      <style>{`
        .footer {
          background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
          color: white;
          position: relative;
          overflow: hidden;
        }

        .footer::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, transparent, #ff6b35, #ff8c42, #ff6b35, transparent);
          animation: shimmer 3s infinite;
        }

        @keyframes shimmer {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }

        .footer-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 60px 20px 20px;
        }

        .footer-content {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 40px;
          margin-bottom: 40px;
        }

        .footer-section h3 {
          color: #ff6b35;
          font-size: 20px;
          margin-bottom: 20px;
          font-weight: 700;
          position: relative;
          padding-bottom: 10px;
        }

        .footer-section h3::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 50px;
          height: 3px;
          background: #ff6b35;
          border-radius: 2px;
        }

        .footer-about p {
          color: #aaa;
          line-height: 1.8;
          margin-bottom: 20px;
          text-align:justify;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-links li {
          margin-bottom: 12px;
        }

        .footer-links a {
          color: #aaa;
          text-decoration: none;
          transition: all 0.3s ease;
          display: inline-block;
          position: relative;
          padding-left: 15px;
        }

        .footer-links a::before {
          content: '▸';
          position: absolute;
          left: 0;
          color: #ff6b35;
          transition: transform 0.3s ease;
        }

        .footer-links a:hover {
          color: #ff6b35;
          transform: translateX(5px);
        }

        .footer-links a:hover::before {
          transform: translateX(5px);
        }

        .footer-service-item {
          color: #aaa;
          margin-bottom: 10px;
          padding-left: 15px;
          position: relative;
        }

        .footer-service-item::before {
          content: '✓';
          position: absolute;
          left: 0;
          color: #ff6b35;
          font-weight: bold;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 12px;
          color: #aaa;
          margin-bottom: 15px;
          transition: color 0.3s ease;
        }

        .contact-item:hover {
          color: #ff6b35;
        }

        .contact-item svg {
          width: 20px;
          height: 20px;
          color: #ff6b35;
          flex-shrink: 0;
        }

        .social-links {
          display: flex;
          gap: 15px;
          margin-top: 20px;
        }

        .social-link {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(255, 107, 53, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ff6b35;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .social-link:hover {
          background: #ff6b35;
          color: white;
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(255, 107, 53, 0.3);
        }

        .social-link svg {
          width: 20px;
          height: 20px;
        }

        .footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding-top: 30px;
          text-align: center;
        }

        .footer-bottom p {
          color: #888;
          margin: 8px 0;
          font-size: 14px;
        }

        .footer-bottom p:first-child {
          color: #aaa;
          font-size: 15px;
        }

        @media (max-width: 768px) {
          .footer-content {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .footer-container {
            padding: 40px 20px 20px;
          }

          .footer-section h3 {
            font-size: 18px;
          }
        }

        .pulse-animation {
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.7;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            {/* About Section */}
            <div className="footer-section footer-about">
              <h3>{currentContent.about.title}</h3>
              <p>{currentContent.about.description}</p>
              <div>
                <p style={{ color: '#ff6b35', marginBottom: '10px', fontWeight: '600' }}>
                  {currentContent.followUs}
                </p>
                <div className="social-links">
                  <div className="social-link" title="Facebook">
                    <Facebook />
                  </div>
                  <div className="social-link" title="Instagram">
                    <Instagram />
                  </div>
                  <div className="social-link" title="Twitter">
                    <Twitter />
                  </div>
                  <div className="social-link" title="LinkedIn">
                    <Linkedin />
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h3>{currentContent.quickLinks.title}</h3>
              <ul className="footer-links">
                {currentContent.quickLinks.links.map((link, index) => (
                  <li key={index}>
                    <Link to={routes[index]}>{link}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="footer-section">
              <h3>{currentContent.services.title}</h3>
              {currentContent.services.items.map((service, index) => (
                <div key={index} className="footer-service-item">
                  {service}
                </div>
              ))}
            </div>

            {/* Contact */}
            <div className="footer-section">
              <h3>{currentContent.contact.title}</h3>
              <div className="contact-item">
                <Mail />
                <span>{currentContent.contact.email}</span>
              </div>
              <div className="contact-item">
                <Phone />
                <span>{currentContent.contact.phone}</span>
              </div>
              <div className="contact-item">
                <MapPin />
                <span>{currentContent.contact.address}</span>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="footer-bottom">
            <p>{currentContent.copyright}</p>
            <p className="pulse-animation">{currentContent.designedBy}</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;